// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"8":"341c9b0d","46":"12ae63df","97":"57c014b9","453":"aa0c5d87","572":"d684e108","756":"ffb2ec14","785":"2f4e996a","819":"0ec17212","822":"5ba0f2cc"}[chunkId] + ".chunk.js";
};